<ninja-keys
  #ninjaKeys
  data-hj-suppress
  placeholder="{{ 'Type a command or search' | translate }}..."
  (selected)="onActionSelected($event)"
>
  <div slot="footer" class="flex gap-md p-sm text-sm text-default">
    <div class="flex gap-xs">
      <sb-badge size="xsmall" color="grey">
        <sb-icon name="corner-down-left-regular" />
      </sb-badge>
      {{ 'to select' | translate }}
    </div>
    <div class="flex gap-xs">
      <sb-badge size="xsmall" color="grey">
        <sb-icon name="arrow-up-regular" />
      </sb-badge>
      <sb-badge size="xsmall" color="grey">
        <sb-icon name="arrow-down-regular" />
      </sb-badge>
      {{ 'to navigate' | translate }}
    </div>
    <div class="flex gap-xs">
      <sb-badge size="xsmall" color="grey"> esc </sb-badge>
      {{ 'to close' | translate }}
    </div>
    <div class="flex gap-xs">
      <sb-badge size="xsmall" color="grey">
        <sb-icon name="delete-back-regular" />
      </sb-badge>
      {{ 'move to parent' | translate }}
    </div>
  </div>
</ninja-keys>
